import { Injectable } from '@angular/core';

import { Oauth2RessourceServiceBase } from '../baseBtl/oauth2/oauth2-resources.service';

export const Config: any = { ENV: 'DEV' };

/**
 * @todo : Créer une interface pour oauthParams
 */
@Injectable({
    providedIn: 'root',
})
export class Oauth2RessourceService extends Oauth2RessourceServiceBase {
    protected getInstance(): this {
        if (this.inService) {
            return this;
        } else {
            const instance: this = new Oauth2RessourceService(
                this.oauth2,
                this.http,
                this.configService,
                this.btlHelper,
                this.prismeService,
                this.optionConfig,
            ) as this;
            instance.inService = true;
            return instance;
        }
    }

    public prm(): this {
        const resource = this.getInstance();
        resource.resourceUrl += '/prm';
        return resource;
    }
}
